<template>
  <modal :show.sync="modalStatus" :show-close="false">
    <template slot="header">
      {{ translate(`${modalAction} Blacklist Details`) }}
    </template>
    <el-form ref="form" slot="default" label-position="top" label-width="100px">
      <b-col lg="12">
        <base-input
          :label="translate('Filter Type')"
          :rules="{ required: true }"
        >
          <select
            v-model="form.attributes['type']"
            class="text-center form-control"
          >
            <option
              v-for="(opt, i) in filterTypeOptions"
              class="text-center"
              :key="i"
              :label="opt.label"
              :value="opt.value"
            ></option>
          </select>
        </base-input>
        <base-input
          v-model="form.attributes['value']"
          :type="form.attributes['type'] === 'email' ? 'email' : 'number'"
          :label="translate('Value Filtered')"
          :rules="{ required: true }"
        ></base-input>
        <base-input
          type="text"
          v-if="form.attributes['created-at']"
          v-model="form.attributes['created-at']"
          :label="translate('Created At')"
          :rules="{ required: true }"
          readonly=""
        ></base-input>
      </b-col>
    </el-form>
    <template slot="footer">
      <base-button
        type="primary"
        :disabled="
          !form.attributes['type'] ||
          !form.attributes['value'] ||
          !isValidEmail ||
          isLoading
        "
        @click="onSave"
        >{{ form.id ? translate("Update") : translate("Save") }}</base-button
      >
      <base-button type="link" class="ml-auto" @click="handleClose">{{
        translate("Close")
      }}</base-button>
    </template>
  </modal>
</template>

<script>
import {
  Table,
  TableColumn,
  Button,
  Form,
  FormItem,
  Select,
  Option,
} from "element-ui";
import { translations } from "@/mixins";
import { Customer } from "@/services/SOLO";

export default {
  name: "BlacklistSingleModal",
  props: {
    blacklistSingle: {
      type: null,
      default: null,
    },
    modalStatus: {
      type: Boolean,
      default: false,
    },
    modalAction: {
      type: String,
      default: "",
    },
  },
  mixins: [translations],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      form: {
        attributes: {
          value: "",
          type: "",
          "created-at": "",
          "updated-at": "",
        },
      },
      filterTypeOptions: [
        {
          label: "Phone number",
          value: "phone_number",
        },
        {
          label: "Email",
          value: "email",
        },
      ],
      isValidEmail: false,
      firstAction: "",
      isLoading: false,
    };
  },
  methods: {
    async onSave() {
      this.isLoading = true;
      const payload = {
        type: this.form.attributes.type,
        value: this.form.attributes.value,
      };
      const notifyOptions = {
        title: `${this.form?.id ? "UPDATE" : "CREATE"} DATA`,
        verticalAlign: "bottom",
        horizontalAlign: "left",
        message: `Blacklist data was ${
          this.form?.id ? "updated" : "created"
        } successfully!`,
        type: "success",
      };
      if (this.form?.id) {
        const response = await Customer.updateBlacklist(this.form.id, payload);
        this.$notify(notifyOptions);
        this.$emit("close", "update", response);
      } else {
        const response = await Customer.createBlacklist(payload);
        this.$notify(notifyOptions);
        this.$emit("close", "create", response);
      }
      this.isLoading = false;
    },
    handleClose() {
      this.$emit("close");
    },
  },
  watch: {
    blacklistSingle(newData) {
      if (!newData) {
        this.form = {
          attributes: {
            value: "",
            type: "",
            "created-at": "",
            "updated-at": "",
          },
        };
      } else {
        this.form = newData;
      }
    },
    "form.attributes.type"(newData) {
      if (
        (this.modalAction !== "Update" && !this.firstAction) ||
        this.firstAction
      ) {
        this.form.attributes.value = "";
      }
      this.firstAction = newData;
    },
    "form.attributes.value"(newData) {
      if (this.form.attributes.type === "email") {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        this.isValidEmail = emailPattern.test(newData);
      } else {
        this.isValidEmail = true;
      }
    },
  },
};
</script>
